import { render, staticRenderFns } from "./ComparisonTable.vue?vue&type=template&id=6d5182e8&"
import script from "./ComparisonTable.vue?vue&type=script&lang=js&"
export * from "./ComparisonTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports